import { selectUserShortcuts } from 'containers/Login/loginSlice'
import ActionsButton from 'components/ActionsButton'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { getIcon, getPath } from './constans'
import { useSelector } from 'react-redux'
import Error from 'components/Error'
import { Fragment } from 'react'

const Shortcuts = () => {
  const shortcuts = useSelector(selectUserShortcuts)

  const { t } = useTranslation('dashboard')
  const { push } = useHistory()

  const renderActionButton = (index) => {
    const value = shortcuts[index]?.value
    return value
      ? <ActionsButton
        text={t(value)}
        Icon={getIcon(value)}
        action={() => {
          push(getPath(value))
        }} />
      : null
  }

  return (
    <div className='dashboard__shortcuts'>
      {shortcuts && shortcuts.length > 0
        ? <div className='actionsButton__buttons'>
          {shortcuts?.map((_, idx) => {
            if (idx !== 0 && idx !== 3) return null
            return <Fragment key={idx}>
              <div className='buttons__row center'>
                {renderActionButton(idx)}
                {shortcuts[idx + 1] && <hr />}
                {renderActionButton(idx + 1)}
                {shortcuts[idx + 2] && <hr />}
                {renderActionButton(idx + 2)}
              </div>
              {!idx && shortcuts.length > 3 && <hr />}
            </Fragment>
          })}
        </div>
        : <Error
          staticPos
          text={t('noShortcuts')}
        />}
    </div>
  )
}

export default Shortcuts
